<template>
  <div class="number row" :class="{ 'custom-input' : customInput }" >
    <fa v-if="faClass" :fa-class="faClass" />

    <div class="input-inner" :class="{ row : inlineDisplay }">
      <div v-if="label" :class="getLabelClass">
        {{ $t(label) }}
      </div>

      <b-input-group v-bind="inputGroupProps" :class="{ 'col-4' : inlineDisplay }">
        <b-form-input :type="type"
                      :name="name"
                      :min="min"
                      :max="max"
                      v-model="val"
                      :placeholder="$t(placeholder)"
                      :required="required"
                      :read-only="readOnly"
                      :disabled="disabled"
                      :help="help"
                      :formatter="formatter"
                      :state="state"
        />
      </b-input-group>
      <label id="helpLabel" v-if="help" for="input-modal">{{ help }}</label>

      <span v-if="type === 'range'">
        {{ val }}
      </span>
    </div>

    <error v-if="displayError">
      {{ errorMessage }}
    </error>
  </div>
</template>

<script>
import fa from '@/components/global/icon/fontAwesome'
import bFormInput from 'bootstrap-vue/es/components/form-input/form-input'
import formMethods from '@/components/frontoffice/mixins/formMethods'
import error from '@/components/frontoffice/form/error'

export default {
  components: {
    fa,
    bFormInput,
    error
  },

  mixins: [formMethods],

  props: {
    customInput: {
      type: Boolean,
      default: true
    },
    name: {
      type: String,
      required: true
    },
    faClass: String,
    label: String,
    placeholder: {
      type: String,
      default: ''
    },
    value: {
      type: [Number, String],
      default: 0
    },
    help: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: true
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 9999999999999999999999
    },
    type: {
      type: String,
      default: 'number'
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    disabled: Boolean,
    isPrice: {
      type: Boolean,
      default: false
    },
    inlineDisplay: {
      type: Boolean,
      default: false
    },
    noZero: {
      type: Boolean,
      default: false
    },
    state: {
      type: Boolean,
      default: null
    }
  },

  data () {
    return {
      val: this.value,
      displayError: false,
      errorMessage: ''
    }
  },

  methods: {
    formatter (val) {
      if (this.noZero && val == 0) return null
      return val
    }
  },

  computed: {
    inputGroupProps () {
      return this.isPrice ? {
        append: '€'
      } : {}
    },

    getLabelClass () {
      let ret = this.required ? 'label required' : 'label'
      if (this.inlineDisplay) ret += ' col-8'
      return ret
    }
  },

  watch: {
    val (newValue, oldValue) {
      this.$emit('input', newValue)
    }
  }
}
</script>
